// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__3U7Cu","content":"style_content__3D-IH","title":"style_title__2EsF2","cards":"style_cards__I6ugZ"};